// eslint-disable-next-line
import Symbol_observable from 'symbol-observable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('ee-root'));

export default {};
